export default __webpack_public_path__ + "static/media/search-curriculum.4e229f9b.svg";